const PRODUCT_TYPE_OPTIONS = [
  // { value: "general", label: "General" },
  { value: "mortgage", label: "Mortgages" },
  {
    value: "debt_consolidation_mortgage",
    label: "Debt Consolidation (or further borrowing)",
  },
  { value: "btl_mortgage", label: "BTL Mortgage" },
  { value: "commercial_mortgage", label: "Commercial Mortgage" },
  { value: "bridging_loan", label: "Regulated Bridging" },
  { value: "equity_release", label: "Equity Release" },
  // { value: "pensions_investments", label: "Pensions and Investments" },
  { value: "pensions_and_investments", label: "Pensions and Investments" },
  { value: "investments", label: "Investments" },
  { value: "pensions", label: "Pensions" },
  // {
  //   value: "defined_benefit_pension",
  //   label: "DB Pensions (by referral only)",
  // },
  {
    value: "defined_benefit_pension",
    label: "DB Pensions (by referral only)",
  },
  { value: "capital_at_risk", label: "Capital At Risk" },
  { value: "will_writing", label: "Will Writing" },
  {
    value: "estate_inheritance_planning",
    label: "Estate & Inheritance Planning",
  },
  { value: "external_links", label: "External Links" }, // <-- NEW checkbox
];



const MEDIA_TYPE_OPTIONS = [
  "Website Content",
  "Social Media Content",
  "Newsletter",
  "Blog Post/Article",
  "Document/Report",
  "Podcast",
  "Stationery (Business Cards, Logos, etc.)",
  "Other",
];

export { PRODUCT_TYPE_OPTIONS };
export { MEDIA_TYPE_OPTIONS };